import CampGameReconmmend from "components/view/camp_game_recommend";
import { AppReducerStateProps } from "lib/store";
import LayoutMaster from "../../components/layout/layout_master";
import { connect } from "react-redux";
import { TopBannerOtherCasino } from "components/view/top_banner_other_casino";
import Img from "react-cloudimage-responsive";
import { prefix } from "lib/worker/client";
import Link from "next/link";
import {
  CheckWithPrefix,
  CheckWithPrefixResponse,
} from "lib/infomation_vender/document";
import { GetServerSideProps } from "next";

export interface Props {
  toggleState: boolean;
  state: AppReducerStateProps;
  infomation: CheckWithPrefixResponse;
}

function UfaBet(props: Props) {
  return (
    <LayoutMaster
      content_setting={{
        title: "UFABET คาสิโน และ สล็อตออนไลน์",
        description:
          "เว็บพนันออนไลน์ UFABET เว็บตรง ทำรายการได้รวดเร็วการทำรายการ ฝาก ถอน เงินเข้าระบบ UFABET หรือการถอนออกจากระบบ UFABET ทำด้วยระบบอัตโนมัติ",
      }}
      information={props.infomation}
    >
      <div className="children-top-margin">
        <TopBannerOtherCasino
          logo={"ufabet-campgame2.png"}
          desc={"คาสิโนและกีฬาออนไลน์"}
          campName={"UFABET"}
          isButton={true}
          venderPrefix={"ufabet"}
          symbol="ufabet"
        ></TopBannerOtherCasino>
      </div>

      <div className="container margin-top-10">
        <div>
          <Img
            className="border-radius"
            ratio={2.1}
            src="banner-ufabet-3.png"
            alt="UFABET บาคาร่าออนไลน์ คาสิโนออนไลน์"
          ></Img>
        </div>
        <div
          className="card color-font-card"
          style={{ padding: 20, marginTop: 20 }}
        >
          <div className="font-bold">
            <h1>
              <span>UFABET โปรโมชั่นสุดพิเศษ</span>
            </h1>
          </div>
          <p className="bottom-line-yellow"></p>
          <p>
            พนันออนไลน์ เว็บตรงไม่ผ่านเอเย่นต์ที่ดีที่สุด ไม่ว่าจะเป็นการแทงบอล
            เดิมพันกีฬาต่างๆ คาสิโนออนไลน์ บาคาร่า สล็อต ไฮโล ยิงปลา
            และอีกมากมาย
            ทางเว็บไซต์เราได้รวบรวมเกมพนันจากค่ายดังชั้นนำไว้ที่นี่มากกว่า 100
            เกม
            แต่เว็บไซต์พนันเหล่านี้ต่างมีการแข่งขันที่สูงในปัจจุบันมีมากมายหลายเว็บไซต์
            แน่นอนคุณต้องเลือกเว็บไซต์ที่ดีที่สุด มีโปรโมชั่นที่น่าสนใจ
            และต้องคุ้มค่าที่สุด ดังนั้นทางเว็บไซต์ UFABET เว็บตรง
            ไม่ผ่านเอเย่นต์ ที่เข้าถึงความต้องการของลูกค้า เล่นง่าย แตกบ่อย
            จ่ายจริง คืนยอดเสียทุกสัปดาห์ สมัครสมาชิกรับฟรีเครดิต 100%
            มีโปรโมชั่นรายวันรับอีก 50% เลยทีเดียว
            จึงมอบสิทธิพิเศษมากกว่าเว็บอื่นๆ
          </p>
        </div>

        <div
          className="card color-font-card"
          style={{ padding: 20, marginTop: 20 }}
        >
          <div className="font-bold">
            <h2>
              <span>พนันออนไลน์ UFABETเว็บตรง เล่นง่าย แตกง่าย จ่ายจริง</span>
            </h2>
          </div>
          <p className="bottom-line-yellow"></p>
          <p>
            คาสิโนออนไลน์ที่ดีที่สุดในประเทศไทย
            เปิดให้บริการเกมพนันให้ผู้เล่นได้เลือกเดิมพันตามความต้องการหลากหลายรูปแบบ
            เช่น คาสิโนสด หรือ แทงบอลออนไลน์ แต่ที่ผู้คนส่วนมากสนใจก็คือ
            เกมสล็อต เว็บพนันที่ดีควรมีเกมให้ผู้เล่นได้เลือกเดิมพันแบบครบเครื่อง
            มีโปรโมชั่นที่หลากหลาย แนะนำเลยว่าต้องเว็บ UFABET เท่านั้น
            การันตีจากสมาชิกที่เก่าและสมาชิกใหม่ที่เพิ่มขึ้นอย่างต่อเนื่อง
            ทางเรามี ค่ายสล็อต มากมายให้ท่านได้เลือกตามใจชอบ เช่น{" "}
            <span>PGSLOT, JOKER GAMING, PRAGMATIC, RED TIGER</span> เป็นต้น
            จากค่ายดังระดับแนวหน้า ทางเว็บไซต์มีการพัฒนาอัพเดท
            นำเกมใหม่ๆเข้ามาเพื่อตอบโจทย์ตามความต้องการของผู้เล่น
            ท่านสามารถเล่นผ่านมือถือและคอมพิวเตอร์ได้ทุกที่ทุกเวลา
            เล่นง่ายด้วยความสะดวกสบาย แค่กระเป๋าเดียว
            เพื่อให้ผู้เล่นเปลี่ยนค่ายเกมเล่น โดยไม่จำเป็นต้องโยกเงินไปมา
            ให้ยุ่งยากเสียเวลาท้าให้ลองกับเว็บที่ดีที่สุดอันดับ1
            กับเว็บเรารับรองว่าท่านจะสนุกเพลิดเพลินกับเกมที่หลากหลายและโปรโมชั่นสุดพิเศษและของรางวัลอีกมากมาย
          </p>
        </div>

        <div
          className="card color-font-card"
          style={{ padding: 20, marginTop: 20 }}
        >
          <div className="font-bold">
            <h2>
              <span>สมัครUFABET เว็บพนันออนไลน์ สมัครไม่มีขั้นต่ำ</span>
            </h2>
          </div>
          <p className="bottom-line-yellow"></p>
          <p>
            สมัครสมาชิกกับเว็บไซต์เรา UFABETมือถือ มีโปรโมชั่นรายวัน
            ฟรีเครดิต50% จากยอดฝาก สมัครสมาชิกตอนนี้ แถมโปรโมชั่น เกมสล็อต
            รับโบนัสสูงสุด 500 บาทกันเลยทีเดียว ท่านสามารถเล่นได้ทุกเกมบนเว็บ
            ยูฟ่าเบท ไม่ว่าจะเป็น แทงบอล บาคาร่า เกมสล็อต
            หรือยิงปลาแถมยังมีกิจกรรมรับเครดิตฟรี uDiamond
            สามารถสะสมนำไปแลกเป็นเครดิตได้และยังมีเกมกงล้อลุ้นรางวัล
            แจกหนักให้กับสมาชิก ด้วยรางวัลใหญ่ คือ IPHONE13PRO
            หมุนได้เอาไปเลยฟรีๆ หากผู้เล่นดวงไม่ดีนัก
            ทางเข้าUFABETเว็บตรงไม่ผ่านเอเย่นต์ มีรางวัลปลอบใจ
            ด้วยการคืนยอดเสียทุกการเดิมพันเป็นค่าคอมมิชชั่นสูงที่สุดถึง 0.75%
            เว็บไซต์เราใส่ใจสมาชิกทุกท่าน หากสนใจสมัคร{" "}
            <Link href={`/register/${prefix}`}>
              <a>
                <span style={{ textDecoration: "underline" }}>คลิกที่นี่</span>
              </a>
            </Link>{" "}
            ได้เลย ขอให้สนุกเพลิดเพลินกับเว็บของเรา เว็บพนันUFABET
          </p>
        </div>
        <CampGameReconmmend></CampGameReconmmend>
      </div>
    </LayoutMaster>
  );
}
export const getServerSideProps: GetServerSideProps<any> = async (context) => {
  const { req } = context;
  console.log("COTEXT =>", req.headers.host);
  console.log("query =>", context.query);
  const infomation = CheckWithPrefix({ host: req.headers.host as string });

  return {
    props: {
      isLogin: context.req.cookies.access_token != undefined,
      infomation: infomation,
    },
  };
};

const mapStateToProps = (state: AppReducerStateProps) => {
  return {
    state: state,
  };
};

export default connect(mapStateToProps)(UfaBet);
